jQuery(document).ready(function( $ ){

    function checkVideoSource() {
        // adds the necessary src query strings depending on what video provider was set. (a.k.a video-source)
        var vidMain, vidProvider;
        vidMain = $(".hero-video.hero-slide");
        vidProvider = vidMain.data("video-source");
        var videoIframeElement = vidMain.find('iframe');
        var iframeSrc = videoIframeElement.attr("src");
        if (vidProvider === 'vimeo') {
            var qstrings = ["controls=0","autopause=0","autoplay=1","loop=1","api=1","muted=1"];
            qstrings.forEach(qstring => {
                if (!iframeSrc.includes(qstring)) {
                    iframeSrc += `&${qstring}`;
                }
            });
            videoIframeElement.attr('src', iframeSrc);
        }
    }

    function playPauseVideo(control) {
        var videoContainer, slideType, player;

        videoContainer = $(".hero-video.hero-slide");
        var videoIframeElement = videoContainer.find('iframe');
        slideType = videoContainer.data("video-source");
        player = videoIframeElement.get(0);

        if (slideType === 'vimeo') {
            switch (control) {
                case 'play':
                    postMessageToPlayer(player, {
                    'method': 'play',
                    'value': 1
                    });
                    postMessageToPlayer(player, {
                        'method': 'setMuted',
                        'value': false
                    });
                    break;
                case 'pause':
                    postMessageToPlayer(player, {
                    'method': 'pause',
                    'value': 1
                    });
                    break;
            }
        } else if (slideType === 'youtube') {
            switch (control) {
                case 'play':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'mute'
                    });

                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'playVideo'
                    });
                    break;
                case 'pause':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'pauseVideo'
                    });
                    break;
            }
        }
    }

    function sendControlToVideo(control = 'play', whichVideo = ".hero-video.hero-slide") {
        var videoContainer = $(whichVideo);
        var videoIframeElement = videoContainer.find('iframe');
        var slideType = videoContainer.data("video-source");
        var player = videoIframeElement.get(0);

        if (slideType === 'vimeo') {
            switch (control) {
                case 'play':
                    postMessageToPlayer(player, {
                    'method': 'play',
                    'value': 1
                    });
                    break;
                case 'pause':
                    postMessageToPlayer(player, {
                    'method': 'pause',
                    'value': 1
                    });
                    break;
                case 'unmute':
                    postMessageToPlayer(player, {
                        'method': 'setMuted',
                        'value': false
                    });
                    break;
                case 'mute':
                    postMessageToPlayer(player, {
                        'method': 'setMuted',
                        'value': true
                    });
                    break;

            }
        } else if (slideType === 'youtube') {
            switch (control) {
                case 'play':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'playVideo'
                    });
                    break;
                case 'pause':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'pauseVideo'
                    });
                    break;
                case 'unmute':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'unMute'
                    });
                    break;
                case 'mute':
                    postMessageToPlayer(player, {
                        'event': 'command',
                        'func': 'mute'
                    });
                    break;
            }
        }
    } 



    function postMessageToPlayer(player, command) {
        if (player == null || command == null) return;
        player.contentWindow.postMessage(JSON.stringify(command), '*');
    }

    // $(window).load(function () {
    // When the slide is changing
    $(document).on('click', '.play-video', function () {
        sendControlToVideo('play');
        $(this).removeClass('play-video').addClass('pause-video');
        $(this).attr("title","Pause video");
    });

    $(document).on('click', '.pause-video', function () {
        sendControlToVideo('pause');
        $(this).removeClass('pause-video').addClass('play-video');
        $(this).attr("title","Play video");
    });

    $(document).on('click', '.unmute-video', function () {
        sendControlToVideo('unmute');
        $(this).removeClass('unmute-video').addClass('mute-video');
        $(this).attr("title","Mute video");
    });

    $(document).on('click', '.mute-video', function () {
        sendControlToVideo('mute');
        $(this).removeClass('mute-video').addClass('unmute-video');
        $(this).attr("title","Unmute video");
    });

    checkVideoSource();

    // setTimeout(function () {
    //     $(".play-video").click();
    // }, 1000);

    // if ($(window).width() <= 640) {
    // function myStopFunction() {
    //     clearInterval(vimeoInterval);
    // }
    // function vimeoPlay() {
    //     playPauseVideo('play');
    //     var vid = $(".hero-video.hero-slide").find("video");
    //     if (vid.playing) {
    //         myStopFunction();
    //     }
    // }
    // var vimeoInterval = setInterval(vimeoPlay, 300);
    // }
});